module.exports = __webpack_public_path__ + "static/img/ann.9df34124.png";